import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

interface ButtonGlyntProps extends Omit<MuiButtonProps, 'size'> {
  children: React.ReactNode;
  size?: 'xs' | 'small' | 'medium' | 'large';
  onClick?: () => void;
  startIcon?: React.ReactNode;
}

const ButtonGlynt: React.FC<ButtonGlyntProps> = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  sx,
  onClick,
  startIcon,
  disabled,
  ...props
}) => {
  const sxProps = {
    ...(size === 'xs' && {
      padding: '4px 8px',
      fontSize: '0.75rem',
      minHeight: '24px',
    }),
    ...(variant === 'outlined' &&
      color === 'inherit' && {
        border: '1px solid #BDC3D2',
      }),
    ...(color === 'primary' && {
      border: disabled ? '1px solid transparent' : '1px solid #65BBA9',
    }),

    '&.Mui-disabled': {
      color: 'rgba(0,0,0,0.38)',
      cursor: 'not-allowed',
    },
    ...sx,
  };

  return (
    <MuiButton
      variant={variant}
      color={color}
      size={size === 'xs' ? 'small' : size}
      sx={sxProps}
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default ButtonGlynt;
